import api from './http';

// Documents (GED ESS)
export const getDocuments = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/documents${queryString ? `?${queryString}` : ''}`);
};
export const uploadDocument = (formData) => api.post('/documents/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const downloadDocument = (id) => api.get(`/documents/${id}/download`, { responseType: 'blob' });
export const viewDocument = (id) => api.get(`/documents/${id}/view`, { responseType: 'blob' });
export const deleteDocument = (id) => api.delete(`/documents/${id}`);

// GED registres
export const getGedRegisters = () => api.get('/ged/registers');
export const getGedRegisterDocuments = (key) => api.get(`/ged/registers/${encodeURIComponent(key)}`);
export const assignDocumentFolder = (docId, folderPath) => api.patch(`/ged/documents/${docId}/folder`, { folder_path: folderPath });

// Formation documents (Adhesion, Salle, Convention-cadre FORMA'SCOP)
export const listFormationTemplates = (dossierId) => api.get(`/dossiers/${dossierId}/formation-docs/templates`);
export const generateFormationDoc = (dossierId, doc_type, context = {}) =>
  api.post(`/dossiers/${dossierId}/formation-docs/generate`, { doc_type, context });
export const signDocument = (docId, payload) => api.post(`/documents/${docId}/sign`, payload);
export const listDocumentSignatures = (docId) => api.get(`/documents/${docId}/signatures`);

// CMC documents
export const getCmcTemplates = () => api.get('/cmc/documents/templates');
export const generateCmcDocument = (docType, params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return api.get(`/cmc/documents/${docType}/generate${qs ? `?${qs}` : ''}`, { responseType: 'blob' });
};
